import Vue from 'vue'
import VueRouter, { Route, RouteConfig } from 'vue-router'
import App from "./App.vue";
import axios from 'axios'

import router from "./router";
import ProjectHub from './code/ProjectHub'

import _ from "lodash";
import VueLodash from "vue-lodash";

import BootstrapVue from "bootstrap-vue";
import VueNumeralFilterInstaller from 'vue-numeral-filter';
import VueMoment from "vue-moment";
import i18n from "./i18n"

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import { store } from './stores/store'
Vue.config.productionTip = false
Vue.prototype.$http = axios

Vue.use(ProjectHub)
Vue.use(BootstrapVue);
Vue.use(VueLodash);
Vue.use(VueNumeralFilterInstaller, { });
Vue.use(VueMoment);
  
axios.interceptors.request.use(req => {
  req.headers.common.Locale = store.getters.locale;

  if (Vue.prototype.$projectHub) {
    //Seed the known SignalR connection/group Ids with each request.
    req.headers.common.SnlrGroupId = Vue.prototype.$projectHub.GroupId();
    req.headers.common.SnlrConnectionId = Vue.prototype.$projectHub.ConnectionId();
    
  }
  
  
  // Important: request interceptors **must** return the request.
  return req;
});

router.beforeEach((to, from, next) => {
  
  //@ts-ignore
  let init = store.state.context.initialized;

  if (!init) {
     store.dispatch('context/restoreContext')
      .catch(({response})=> {
        //Not authenticated
        if (response.status != 401) {
          console.log(response);
        }
      })
      .finally(() => {
        let isAuth = store.getters["context/isAuthenticated"];
        let isAdmin = store.getters["context/isAdmin"];

        let loginRoute = { name: 'login', query: null as any};
        if (to.path  != '/') {
          loginRoute.query = { redirect: to.path };
        }

        if (to.name !== 'login' && !isAuth) {
          next(loginRoute)
        } else if (to.path && to.path.toLowerCase().startsWith('/admin') && !isAdmin)  { 
          next({ name: 'not-authorized', query: { path: to.path } }) 
        } else {
          next();
        }
      })
  } else {
    let isAuth = store.getters["context/isAuthenticated"];
    let isAdmin = store.getters["context/isAdmin"];

    if (to.name !== 'login' && !isAuth) {
      next({ name: 'login', query: { redirect: to.path } })
    } else if (to.path && to.path.toLowerCase().startsWith('/admin') && !isAdmin)  {
      next({ name: 'not-authorized', query: { path: to.path } }) 
    } else {
      next();
    }
  }
})

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
